module.exports = __webpack_public_path__ + "img/banner_marketing.0db8c33f.jpg";